import React from "react";
import LightGallery from "lightgallery/react";

// import styles
import "lightgallery/css/lightgallery.css";
import "lightgallery/css/lg-zoom.css";
import "lightgallery/css/lg-thumbnail.css";

// import plugins if you need
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

export default function Gallery() {
  const onInit = () => {
    console.log("lightGallery has been initialized");
  };
  return (
    <div>
      <LightGallery
        elementClassNames="mx-auto mt-10     pt-10 sm:mt-12 sm:pt-12 lg:mx-0 lg:max-w-none sm:columns-2 lg:columns-4"
        onInit={onInit}
        speed={500}
        plugins={[lgThumbnail, lgZoom]}
      >
        {Array.from(Array(50), (e, i) => {
          return (
            <a href={`gallery/${i}.jpg`} >
              <img
                className="rounded-3xl  ease-in-out duration-200 hover:scale-105 hover:cursor-pointer mb-5"
                alt={`img${i}`}
                src={`gallery/${i}.jpg`}
              />
            </a>
          );
        })}
      </LightGallery>
    </div>
  );
}
